import { render, staticRenderFns } from "./TerminalUploads.vue?vue&type=template&id=7861ea9b&"
import script from "./TerminalUploads.vue?vue&type=script&lang=js&"
export * from "./TerminalUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports